import { Box } from '@customink/pigment-react';
import type { ProjectItemDraft } from '@customink/project-service-react-components';
import {
  hasView,
  useProduct,
} from '@customink/project-service-react-components';

import ProofImage from '../ProofImage';

import { spacing8 } from '@/utils/designTokens';

type ProjectItemAddProofImagesProps = {
  projectItem: ProjectItemDraft;
  colorId?: number;
};

export const ProjectItemAddProofImages = ({
  projectItem,
  colorId,
}: ProjectItemAddProofImagesProps) => {
  const { data: product } = useProduct({ colorId });

  return (
    <Box display="flex" flexDirection="row" gap={spacing8} width="100%">
      <Box
        component="div"
        sx={{
          aspectRatio: '1',
          borderRadius: '8px',
          maxWidth: '200px',
          minWidth: '80px',
          overflow: 'hidden',
          position: 'relative',
          width: '50%',
        }}
      >
        <ProofImage
          cid={projectItem.design?.cid}
          colorId={colorId}
          view="front_medium_extended.png"
        />
      </Box>
      {hasView('back', product?.views) && (
        <Box
          component="div"
          sx={{
            aspectRatio: '1',
            borderRadius: '8px',
            maxWidth: '200px',
            minWidth: '80px',
            overflow: 'hidden',
            position: 'relative',
            width: '50%',
          }}
        >
          <ProofImage colorId={colorId} view="back_medium_extended.png" />
        </Box>
      )}
    </Box>
  );
};
